import { RecipientType } from '../enums/recipient-type.enum';

/** Contiene las propiedades necesarias para manejar una cuenta */
export class Account {
  /** Código de la cuenta */
  Code: string;
  /** Nombre de la cuenta */
  Name: string;
  /** Agencia */
  Agency: string;
  /** Nombre de la agencia */
  AgencyName: string;
  /** Documento identificativo */
  Nif: string;
  /** Indica si se tiene que desactivar la cuenta */
  Deactivate: boolean;
  RecipientType: RecipientType;
}


